import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden transition-all duration-300 hover:border-primary-200/60">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden bg-background-100">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            width={800}
            height={480}
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3 flex-wrap">
          <span className="text-xs text-primary-600 bg-primary-100/70 px-2.5 py-1 rounded-full whitespace-nowrap">
            {article.date}
          </span>
          <span className="text-xs text-foreground-500 flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {article.views.toLocaleString()}
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">
            {article.readTime}
          </span>
        </div>
        <Link to={`/article/${article.slug}`}>
          <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
      </div>
    </article>
  );
}